import { Skeleton, Stack } from "@mui/material"
import { ReactElement } from "react"

import AppSkeleton from "./appSkeleton"

/** LCT / TTR device comment loading skeleton */
const CommentSkeleton = (): ReactElement => (
    <Stack direction="row" width="100%" spacing={1.5} sx={{ pr: 1 }}>
        <Skeleton variant="circular" width={40} height={40} />
        <Stack flexGrow={1}>
            <Stack direction="row" spacing={1}>
                <AppSkeleton width="110px" variant="text" height={20} />
                <AppSkeleton width="175px" variant="text" height={20} />
            </Stack>

            <AppSkeleton width="110px" variant="text" height={20} />
            <AppSkeleton
                width="80%"
                variant="text"
                height={20}
                sx={{ marginTop: 0.5 }}
            />
        </Stack>
        <AppSkeleton width={22} height={22} />
    </Stack>
)

export default CommentSkeleton
